import { useTranslation } from "react-i18next";
import { Link, useNavigate } from "react-router";
import { AuthLayout } from "../../layouts/Auth";
import { ArrowLeft } from "lucide-react";
import { Mail } from "lucide-react";

export const EmailSent = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const resend = () => {
    void navigate("/forgot-password");
  };

  return (
    <AuthLayout
      icon={
        <div className="flex h-11 w-11 items-center justify-center rounded-full bg-green-100 text-green-700">
          <Mail />
        </div>
      }
      title={t("password.email.check")}
      description={t("password.email.description")}
    >
      <div className="mt-7">
        <div className="mt-5 flex items-center gap-2 text-base leading-6 text-gray-700">
          {t("password.email.receive")}
          <br />
          <p
            onClick={resend}
            className="text-primary cursor-pointer text-sm font-medium"
          >
            {t("password.email.resend")}
          </p>
        </div>

        <div className="text-primary mt-5 cursor-pointer text-sm font-medium">
          <Link className="flex" to="/login">
            <ArrowLeft className="mr-2 h-5 w-5 text-green-700" />
            {t("password.backToLogin")}
          </Link>
        </div>
      </div>
    </AuthLayout>
  );
};
